// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2YXP6","header":"PatientQuestionnaire_header__6RWIT","info":"PatientQuestionnaire_info__3Lp7y"};